AOS.init();
const dataDoEvento = new Date("Dec 12, 2025 19:00:00");
const timeStampDoEvento = dataDoEvento.getTime();
const contaAsHoras = setInterval(function() {
    const agora = new Date();
    const timeStampAtual = agora.getTime();
    const distanciAteOEvento = timeStampDoEvento - timeStampAtual;
    const diaEMms = 86400000;
    const horaEMms = 3600000;
    const minutoEMms = 60000;
    const diasAteOEvento = Math.floor(distanciAteOEvento / diaEMms);
    const horasAteOEvento = Math.floor(distanciAteOEvento % diaEMms / horaEMms);
    const minutosAteOEvento = Math.floor(distanciAteOEvento % horaEMms / 60000);
    const segundosAteOEvento = Math.floor(distanciAteOEvento % minutoEMms / 1000);
    document.getElementById("contador").innerHTML = `${diasAteOEvento} d, ${horasAteOEvento} h, ${minutosAteOEvento} m e ${segundosAteOEvento} s`;
    if (distanciAteOEvento < 0) {
        clearInterval(contaAsHoras);
        document.getElementById("contador").innerHTML = "O evento j\xe1 come\xe7ou!";
    }
}, 1000);

//# sourceMappingURL=index.a002055d.js.map
